import { render, staticRenderFns } from "./CommunicationDialog.vue?vue&type=template&id=312a0434"
import script from "./CommunicationDialog.vue?vue&type=script&lang=js"
export * from "./CommunicationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports